module.exports = __webpack_public_path__ + "img/img_gladiator.41995d18.png";